/**
 * Allys Area Overview Component
 * 
 * Displays area description, coordinates, and key information
 * in an elegant card layout.
 */

'use client';

import type { AreaOverviewProps, AreaPageMessages } from '@routeroyal/theme-core';

export interface AllysAreaOverviewProps extends AreaOverviewProps {
  /**
   * Translation messages
   */
  messages?: AreaPageMessages;
}

export function AllysAreaOverview({
  area,
  additionalContent,
  messages,
  className = '',
}: AllysAreaOverviewProps) {
  return (
    <div 
      className={`bg-white rounded-[2rem] p-10 md:p-14 shadow-[0_4px_20px_-4px_rgba(0,0,0,0.08)] hover:shadow-[0_20px_40px_-12px_rgba(0,0,0,0.12)] border border-gray-100/80 transition-all duration-500 h-full ${className}`}
    >
      <h2 className="font-serif text-3xl md:text-4xl text-[var(--color-text)] mb-8">
        {messages?.theOverview || 'The Overview'}
      </h2>
      
      <div className="prose prose-lg max-w-none prose-headings:font-serif prose-p:text-gray-600 prose-p:font-light prose-p:leading-loose">
        <p className="text-xl md:text-2xl font-serif text-[var(--color-text)]/80 leading-relaxed mb-6">
          {area.description.split('.')[0]}.
        </p>
        <p 
          className="text-gray-600 font-light leading-loose font-inter"
        >
          {area.description.split('.').slice(1).join('.').trim()}
        </p>
        
        {additionalContent && (
          <p 
            className="text-gray-600 font-light leading-loose mt-6 font-inter"
          >
            {additionalContent}
          </p>
        )}
      </div>
    </div>
  );
}
